import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CoreService {

  constructor(private http: HttpClient) {
  }

  fetchDatabase() {
    return this.http.get('/api/datasource/database/');
  }

  fetchCountries() {
    return this.http.get('/api/datasource/countries/');
  }

  fetchUnivesities() {
    return this.http.get('/api/datasource/universities/');
  }

  fetchUniversityFields() {
    return this.http.get('/api/datasource/university-fields/');
  }

  getUniversityFieldsMinMax(field) {
    return this.http.get(`/api/datasource/university-fields/?field=${field}`);
  }

  getRanksMinMax(payload) {
    return this.http.post(`/api/datasource/ratings/`, payload);
  }

  fetchRankFields() {
    return this.http.get('/api/datasource/ratings/');
  }

  fetchDataSource(visualization, fields, filters, benchmarks, settings) {
    // fields: fields.concat(['country', 'name']).join(','),
    return this.http.post(`/api/datasource/data/`, {
      visualization,
      fields,
      filters,
      benchmarks,
      settings
    });
  }

  fetchRatingDataSource(visualization, fields, filters, settings) {
    // fields: fields.concat(['country', 'name']).join(','),
    return this.http.post(`/api/datasource/rating/`, {
      visualization,
      fields,
      filters,
      benchmarks: [],
      settings
    });
  }

  loadFiltered(payload: any) {
    return this.http.post('/api/datasource/filtered/', payload);
  }

  fetchVisualizations() {
    return this.http.get('/api/core/visualization/');
  }

  checkFilters(filters: any) {
    return this.http.post('/api/datasource/check-filters/', {filters: filters});
  }

  fetchTutorial() {
    return this.http.get('/api/help/tutorial/');
  }

  viewTutorial(showNextTime: boolean) {
    return this.http.get(`/api/core/view-tutorial/?show_next=${showNextTime}`);
  }

}
